// Required UI text for widgets that render their own words (DEC-10).
//
// The caller passes every label, already translated. There is NO English
// default on purpose: a default is how "Revenue by Country" and "Low"
// shipped inside Spanish dashboards. A missing or empty key throws, so an
// untranslated widget fails loud in the first render instead of shipping.
//
// Not re-exported from the barrel (index.js): it is an internal helper,
// not a showcase component.
export function requireStrings(component, strings, keys) {
  if (strings === null || typeof strings !== 'object') {
    throw new Error(`${component}: the "strings" prop is required (keys: ${keys.join(', ')})`);
  }
  const missing = keys.filter((k) => typeof strings[k] !== 'string' || strings[k].length === 0);
  if (missing.length > 0) {
    throw new Error(`${component}: "strings" is missing ${missing.join(', ')}`);
  }
  return strings;
}
